import { useMemo } from 'react';
import { useExportHistoryListEmployeeQuery, useExportProgressEmployeeSubscription } from '@/common/graphql';
import { type ExportHistoryKind, toEmployeeExportHistoryRow, type UseExportHistoryResult } from './types';

/** Query + Subscription + row-mapping for `kind: 'employee'`. Always called - internally no-ops via `skip` when inactive. */
export function useExportHistoryEmployee(kind: ExportHistoryKind, onlyMyTask: boolean): UseExportHistoryResult {
  const skip = kind !== 'employee';

  const { data, loading, error, refetch } = useExportHistoryListEmployeeQuery({
    skip,
    fetchPolicy: 'cache-and-network',
    variables: { onlyMyTask },
  });
  const history = useMemo(
    () => (data?.exportHistoryList ?? []).map(toEmployeeExportHistoryRow),
    [data?.exportHistoryList],
  );

  const { data: progressData } = useExportProgressEmployeeSubscription({ skip });
  const progress = useMemo(() => progressData?.exportProgress ?? [], [progressData?.exportProgress]);

  return { error, history, isActive: !skip, loading, progress, refetch };
}
